/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FulfillmentInventoryTransferDto = {
    /**
     * Inventory transfer (TRL) ID
     */
    id: number;
    /**
     * TRL code
     */
    transferCode: string;
    /**
     * TRL status
     */
    status: FulfillmentInventoryTransferDto.status;
    /**
     * When the TRL was completed
     */
    completedAt?: string | null;
};
export namespace FulfillmentInventoryTransferDto {
    /**
     * TRL status
     */
    export enum status {
        PENDING = 'PENDING',
        COMPLETED = 'COMPLETED',
        CANCELLED = 'CANCELLED',
    }
}

